// @flow
import { getSearchUrlWithParams } from '../../../utils/urls';

export const art = [
    {
        columnCategories: [
            {
                headerLink: '/c/art/1/',
                headerText: 'Art',
                links: [
                    {
                        route: '/c/drawings/8/',
                        text: 'Drawings',
                    },
                    {
                        route: '/c/mixed-media-collages/9/',
                        text: 'Mixed Media & Collages',
                    },
                    {
                        route: '/c/paintings/10/',
                        text: 'Paintings',
                    },
                    {
                        route: '/c/photography/11/',
                        text: 'Photography',
                    },
                    {
                        route: '/c/prints-multiples/12/',
                        text: 'Prints & Multiples',
                    },
                    {
                        route: '/c/scrolls-screens-fan-paintings/13/',
                        text: 'Scrolls, Screens & Fan Paintings',
                    },
                    {
                        route: '/c/sculptures/14/',
                        text: 'Sculptures',
                    },
                    {
                        route: '/c/statues-statuettes/26420/',
                        text: 'Statues & Statuettes',
                    },
                ],
            },
        ],
    },
    {
        columnCategories: [
            {
                headerText: 'Artists',
                links: [
                    {
                        route: '/c/art/pablo-picasso/1/18755/',
                        text: 'Pablo Picasso',
                    },
                    {
                        route: '/c/art/banksy/1/2655',
                        text: 'Banksy',
                    },
                    {
                        route: '/c/art/andy-warhol/1/1705/',
                        text: 'Andy Warhol',
                    },
                    {
                        route: '/c/art/jean-michel-basquiat/1/11965/',
                        text: 'Jean-Michel Basquiat',
                    },
                    {
                        route: '/c/art/roy-lichtenstein/1/21418/',
                        text: 'Roy Lichtenstein',
                    },
                    {
                        route: '/c/art/keith-haring/1/14133/',
                        text: 'Keith Haring',
                    },
                    {
                        route: '/c/art/francis-bacon/1/7794/',
                        text: 'Francis Bacon',
                    },
                    {
                        route: '/c/art/frank-stella/1/7962/',
                        text: 'Frank Stella',
                    },
                ],
            },
        ],
    },
    {
        columnCategories: [
            {
                headerText: 'Popular Searches',
                links: [
                    {
                        route: '/c/paintings/oil/10/25830/',
                        text: 'Oil Paintings',
                    },
                    {
                        route: '/c/statues-statuettes/bronze/26420/25739/',
                        text: 'Bronze Statues',
                    },
                    {
                        route: getSearchUrlWithParams({
                            category_id: 1,
                            keyword: 'folk',
                            status: 'online',
                        }),
                        text: 'Folk Art',
                    },
                    {
                        route: getSearchUrlWithParams({
                            category_id: 1,
                            keyword: 'portrait',
                            status: 'online',
                        }),
                        text: 'Portraits',
                    },
                    {
                        route: '/c/paintings/watercolor/10/25898/',
                        text: 'Watercolor Paintings',
                    },
                ],
            },
        ],
    },
];
export const jewelry = [
    {
        columnCategories: [
            {
                headerText: 'Jewelry',
                links: [
                    {
                        route: '/c/bracelets/89/',
                        text: 'Bracelets',
                    },
                    {
                        route: '/c/brooches-pins/90/',
                        text: 'Brooches & Pins',
                    },
                    {
                        route: '/c/cufflinks-tie-pins-tie-clips/91/',
                        text: 'Cufflinks, Tie Pins & Tie Clips',
                    },
                    {
                        route: '/c/costume-jewelry/26441/',
                        text: 'Costume Jewelry',
                    },
                    {
                        route: '/c/earrings/92/',
                        text: 'Earrings',
                    },
                    {
                        route: '/c/loose-stones-beads/94/',
                        text: 'Loose Stones & Beads',
                    },
                    {
                        route: '/c/necklaces-pendants/95/',
                        text: 'Necklaces & Pendants',
                    },
                    {
                        route: '/c/rings/96/',
                        text: 'Rings',
                    },
                    {
                        route: '/c/watches/97/',
                        text: 'Watches',
                    },
                ],
            },
        ],
    },
    {
        columnCategories: [
            {
                headerText: 'Featured',
                links: [
                    {
                        route: '/c/jewelry/cartier/6/3899/',
                        text: 'Cartier',
                    },
                    {
                        route: '/c/jewelry/chanel/6/4017/',
                        text: 'Chanel',
                    },
                    {
                        route: '/c/jewelry/rolex/6/21252/',
                        text: 'Rolex',
                    },
                    {
                        route: '/c/jewelry/bulova/6/3513/',
                        text: 'Bulova',
                    },
                    {
                        route: '/c/jewelry/chopard/6/4393/',
                        text: 'Chopard',
                    },
                    {
                        route: '/c/jewelry/swarovski/6/23012/',
                        text: 'Swarovski',
                    },
                    {
                        route: '/c/jewelry/bulgari/6/3512/',
                        text: 'Bulgari',
                    },
                    {
                        route: '/c/jewelry/patek-philippe/6/18874/',
                        text: 'Patek Philippe',
                    },
                ],
            },
        ],
    },
];
export const asian = [
    {
        columnCategories: [
            {
                headerLink: '/c/asian/158/',
                headerText: 'Asian Antiques',
                links: [
                    {
                        route: '/c/art/asian/1/158/',
                        text: 'Art',
                    },
                    {
                        route: '/c/collectibles/asian/2/158/',
                        text: 'Collectibles',
                    },
                    {
                        route: '/c/fashion/asian/3/158/',
                        text: 'Fashion',
                    },
                    {
                        route: '/c/furniture/asian/4/158/',
                        text: 'Furniture',
                    },
                    {
                        route: '/c/jewelry/asian/6/158/',
                        text: 'Jewelry',
                    },
                    {
                        route: '/c/serveware-flatware-services/asian/86/158/',
                        text: 'Serveware, Flatware & Services',
                    },
                    {
                        route: '/c/vases-garnitures/asian/87/158/',
                        text: 'Vases & Garnitures',
                    },
                ],
            },
        ],
    },
    {
        columnCategories: [
            {
                headerText: 'Browse By Origin',
                links: [
                    {
                        route: '/c/chinese/162/',
                        text: 'Chinese Antiques',
                    },
                    {
                        route: '/c/indian/176/',
                        text: 'Indian Antiques',
                    },
                    {
                        route: '/c/japanese/163/',
                        text: 'Japanese Antiques',
                    },
                    {
                        route: '/c/korean/164/',
                        text: 'Korean Antiques',
                    },
                    {
                        route: '/c/persian/185/',
                        text: 'Persian Antiques',
                    },
                    {
                        route: '/c/southeast-asian/169/',
                        text: 'Southeast Asian Antiques',
                    },
                    {
                        route: '/c/tibetan/168/',
                        text: 'Tibetan Antiques',
                    },
                ],
            },
        ],
    },
    {
        columnCategories: [
            {
                headerText: 'Featured',
                links: [
                    {
                        route: '/c/asian/bronze/158/25739/',
                        text: 'Bronze',
                    },
                    {
                        route: '/c/asian/cloisonne/158/25757/',
                        text: 'Cloisonne',
                    },
                    {
                        route: '/c/han-dynasty/245/',
                        text: 'Han Dynasty',
                    },
                    {
                        route: '/c/jewelry/jade/6/25797/',
                        text: 'Jade Jewelry',
                    },
                    {
                        route: '/c/asian/porcelain/158/25849/',
                        text: 'Porcelain',
                    },
                    {
                        route: '/c/ming-dynasty/246/',
                        text: 'Ming Dynasty',
                    },
                    {
                        route: '/c/qing-dynasty/251/',
                        text: 'Qing Dynasty',
                    },
                    {
                        route: '/c/prints/woodblock/12/25903/',
                        text: 'Woodblock Prints',
                    },
                ],
            },
        ],
    },
];
export const furniture = [
    {
        columnCategories: [
            {
                headerLink: '/c/furniture/4/',
                headerText: 'Furniture',
                links: [
                    {
                        route: '/c/bedframes-headboards/56/',
                        text: 'Bedframes & Headboards',
                    },
                    {
                        route: '/c/cabinets-case-pieces/59/',
                        text: 'Cabinets & Case Pieces',
                    },
                    {
                        route: '/c/seating/26443/',
                        text: 'Seating',
                    },
                    {
                        route: '/c/tables/69/',
                        text: 'Tables',
                    },
                ],
            },
            {
                headerLink: '/c/cabinets-case-pieces/59/',
                headerText: 'Cabinets & Case Pieces',
                links: [
                    {
                        route: '/c/armoires-wardrobes/55/',
                        text: 'Armoires & Wardrobes',
                    },
                    {
                        route: '/c/bookcases-etageres-display-cases/58/',
                        text: 'Bookcases, Etageres & Display Cases',
                    },
                    {
                        route: '/c/chests-of-drawers-commodes/65/',
                        text: 'Chests of Drawers & Commodes',
                    },
                    {
                        route: '/c/sideboards-buffets/67/',
                        text: 'Sideboards & Buffets',
                    },
                ],
            },
        ],
    },
    {
        columnCategories: [
            {
                headerLink: '/c/seating/26443/',
                headerText: 'Seating',
                links: [
                    {
                        route: '/c/benches-stools/57/',
                        text: 'Benches & Stools',
                    },
                    {
                        route: '/c/chairs/61/',
                        text: 'Chairs',
                    },
                    {
                        route: '/c/sofas-chaises/68/',
                        text: 'Sofas & Canapes',
                    },
                ],
            },
            {
                headerLink: '/c/tables/69/',
                headerText: 'Tables',
                links: [
                    {
                        route: '/c/coffee-tables-cocktail-tables/26614/',
                        text: 'Coffee & Cocktail Tables',
                    },
                    {
                        route: '/c/desks-writing-tables/63/',
                        text: 'Desks & Writing Tables',
                    },
                    {
                        route: '/c/dining-tables/64/',
                        text: 'Dining Tables',
                    },
                ],
            },
        ],
    },
    {
        columnCategories: [
            {
                headerText: 'Browse By Style',
                links: [
                    {
                        route: '/c/furniture/art-deco/4/253/',
                        text: 'Art Deco',
                    },
                    {
                        route: '/c/chippendale/277/',
                        text: 'Chippendale',
                    },
                    {
                        route: getSearchUrlWithParams({
                            category_id: 4,
                            keyword: 'federal',
                            status: 'online',
                        }),
                        text: 'Federal Style',
                    },
                    {
                        route: getSearchUrlWithParams({
                            category_id: 4,
                            keyword: 'hollywood regency',
                            status: 'online',
                        }),
                        text: 'Hollywood Regency',
                    },
                    {
                        route: '/c/furniture/mid-century-modern/4/265/',
                        text: 'Mid-Century Modern',
                    },
                    {
                        route: getSearchUrlWithParams({
                            category_id: 4,
                            keyword: 'mission style',
                            status: 'online',
                        }),
                        text: 'Mission Style',
                    },
                    {
                        route: '/c/furniture/rococo/4/260/',
                        text: 'Rococo',
                    },
                    {
                        route: getSearchUrlWithParams({
                            category_id: 4,
                            keyword: 'queen anne',
                            status: 'online',
                        }),
                        text: 'Queen Anne',
                    },
                    {
                        route: '/c/furniture/victorian/4/275/',
                        text: 'Victorian',
                    },
                ],
            },
        ],
    },
    {
        columnCategories: [
            {
                headerText: 'Featured',
                links: [
                    {
                        route: getSearchUrlWithParams({
                            category_id: 4,
                            keyword: 'Eames',
                            status: 'online',
                        }),
                        text: 'Eames Chairs',
                    },
                    {
                        route: '/c/furniture/herman-miller/4/10385/',
                        text: 'Herman Miller',
                    },
                    {
                        route: getSearchUrlWithParams({
                            category_id: 4,
                            keyword: 'hans wegner',
                            status: 'online',
                        }),
                        text: 'Hans Wegner',
                    },
                    {
                        route: '/c/furniture/paul-evans/4/19010/',
                        text: 'Paul Evans',
                    },
                    {
                        route: '/c/furniture/george-nelson/4/8661/',
                        text: 'George Nelson',
                    },
                    {
                        route: '/c/furniture/stickley/4/9563/',
                        text: 'Stickley',
                    },
                    {
                        route: '/c/furniture/milo-baughman/4/17579/',
                        text: 'Milo Baughman',
                    },
                ],
            },
        ],
    },
];
export const collectibles = [
    {
        columnCategories: [
            {
                headerText: 'Collectibles',
                links: [
                    {
                        route: '/c/advertisements-signs/38/',
                        text: 'Advertisements & Signs',
                    },
                    {
                        route: '/c/automobilia-petroliana/7/',
                        text: 'Automobilia & Petroliana',
                    },
                    {
                        route: '/c/banks-registers-adding-machines/18/',
                        text: 'Banks, Registers & Adding Machines',
                    },
                    {
                        route: '/c/books-magazines-papers/20/',
                        text: 'Books, Magazines & Papers',
                    },
                    {
                        route: '/c/breweriana-beer-signs/26426/',
                        text: 'Breweriana & Beer Signs',
                    },
                    {
                        route: '/c/cameras-photographica/21/',
                        text: 'Cameras & Photographica',
                    },
                    {
                        route: '/c/coins-currency-stamps/24/',
                        text: 'Coins, Currency & Stamps',
                    },
                ],
            },
        ],
    },
    {
        columnCategories: [
            {
                headerText: ' ',
                links: [
                    {
                        route: '/c/figurines-miniatures/28/',
                        text: 'Figurines & Miniatures',
                    },
                    {
                        route: '/c/home-hardware-tools-locks/45/',
                        text: 'Home Hardware, Tools & Locks',
                    },
                    {
                        route: '/c/hunting-fishing/26905/',
                        text: 'Hunting & Fishing',
                    },
                    {
                        route: '/c/maps-globes-atlases/33/',
                        text: 'Maps, Globes & Atlases',
                    },
                    {
                        route: '/c/musical-instruments-music-stands/37/',
                        text: 'Musical Instruments & Music Stands',
                    },
                    {
                        route: '/c/pens-writing-instruments/32/',
                        text: 'Pens & Writing Instruments',
                    },
                    {
                        route: '/c/railroadiana/26431/',
                        text: 'Railroadiana',
                    },
                ],
            },
        ],
    },
    {
        columnCategories: [
            {
                headerText: ' ',
                links: [
                    {
                        route: '/c/radios-audio-equipment/26430/',
                        text: 'Radios & Audio Equipment',
                    },
                    {
                        route: '/c/religious-spiritual-objects/39/',
                        text: 'Religious & Spiritual Objects',
                    },
                    {
                        route: '/c/rocks-shells-minerals/40/',
                        text: 'Rocks, Shells & Minerals',
                    },
                    {
                        route: '/c/scientific-medical-objects/26432/',
                        text: 'Scientific & Medical Objects',
                    },
                    {
                        route: '/c/tobacciana/44/',
                        text: 'Tobacciana',
                    },
                    {
                        route: '/c/toys-trains-games/46/',
                        text: 'Toys, Dolls & Games',
                    },
                    {
                        route: '/c/vanity-items/52/',
                        text: 'Vanity Items',
                    },
                    {
                        route: '/c/wine-spirits/88/',
                        text: 'Wine & Spirits',
                    },
                    {
                        route: '/c/weapons-armor/35/',
                        text: 'Weapons & Armor',
                    },
                ],
            },
        ],
    },
];
export const memorabilia = [
    {
        columnCategories: [
            {
                headerText: 'Memorabilia',
                links: [
                    {
                        route: '/c/carnival-circus-collectibles/23/',
                        text: 'Carnival & Circus Collectibles',
                    },
                    {
                        route: '/c/militaria-war-memorabilia/26903/',
                        text: 'Militaria & War Memorabilia',
                    },
                    {
                        route: '/c/movie-tv-memorabilia/36/',
                        text: 'Movie & TV Memorabilia',
                    },
                    {
                        route: '/c/political-memorabilia/31/',
                        text: 'Political Memorabilia',
                    },
                    {
                        route: '/c/scrapbooks-photo-albums/26901/',
                        text: 'Scrapbooks & Photo Albums',
                    },
                    {
                        route: '/c/sports-memorabilia/42/',
                        text: 'Sports Memorabilia',
                    },
                    {
                        route: '/c/travel-memorabilia-souvenirs/49/',
                        text: 'Travel Memorabilia & Souvenirs',
                    },
                    {
                        route: '/c/theater-memorabilia/26899/',
                        text: 'Theater Memorabilia',
                    },
                ],
            },
        ],
    },
    {
        columnCategories: [
            {
                headerText: '',
                links: [],
            },
        ],
    },
    {
        columnCategories: [
            {
                headerText: 'Featured',
                links: [
                    {
                        route: getSearchUrlWithParams({
                            keyword: 'baseball',
                            status: 'online',
                        }),
                        text: 'Baseball Memorabilia',
                    },
                    {
                        route: getSearchUrlWithParams({
                            keyword: 'elvis presley',
                        }),
                        text: 'Elvis Presley Memorabilia',
                    },
                    {
                        route: getSearchUrlWithParams({
                            keyword: 'Autograph',
                        }),
                        text: 'Autographs',
                    },
                    {
                        route: getSearchUrlWithParams({
                            keyword: 'civil war',
                        }),
                        text: 'Civil War Memorabilia',
                    },
                    {
                        route: getSearchUrlWithParams({
                            keyword: 'world war 1',
                        }),
                        text: 'World War I Memorabilia',
                    },
                    {
                        route: getSearchUrlWithParams({
                            keyword: 'world war 2',
                        }),
                        text: 'World War II Memorabilia',
                    },
                ],
            },
        ],
    },
];
export const home = [
    {
        columnCategories: [
            {
                headerLink: '/c/home-garden/5/',
                headerText: 'Home & Garden',
                links: [
                    {
                        route: '/c/baskets-containers/72/',
                        text: 'Baskets & Containers',
                    },
                    {
                        route: '/c/candle-holders/60/',
                        text: 'Candle Holders',
                    },
                    {
                        route: '/c/clocks/74/',
                        text: 'Clocks',
                    },
                    {
                        route: '/c/fireplaces-mantels/77/',
                        text: 'Fireplaces & Mantels',
                    },
                    {
                        route: '/c/fireplace-accessories/76/',
                        text: 'Fireplace Accessories',
                    },
                    {
                        route: '/c/garden-furniture/66/',
                        text: 'Garden Furniture',
                    },
                ],
            },
        ],
    },
    {
        columnCategories: [
            {
                headerText: ' ',
                links: [
                    {
                        route: '/c/garden-ornaments/79/',
                        text: 'Garden Ornaments',
                    },
                    {
                        route: '/c/frames-shelves-wall-decor/78/',
                        text: 'Frames, Shelves & Wall Decor',
                    },
                    {
                        route: '/c/kitchenware/26446/',
                        text: 'Kitchenware',
                    },
                    {
                        route: '/c/lighting/81/',
                        text: 'Lighting',
                    },
                    {
                        route: '/c/magazine-racks/82/',
                        text: 'Magazine Racks',
                    },
                    {
                        route: '/c/mirrors/83/',
                        text: 'Mirrors',
                    },
                ],
            },
        ],
    },
    {
        columnCategories: [
            {
                headerText: ' ',
                links: [
                    {
                        route: '/c/planters/84/',
                        text: 'Planters',
                    },
                    {
                        route: '/c/rugs-carpets/85/',
                        text: 'Rugs & Carpets',
                    },
                    {
                        route: '/c/serveware-flatware-barware/86/',
                        text: 'Serveware, Flatware & Barware',
                    },
                    {
                        route: '/c/textiles/75/',
                        text: 'Textiles',
                    },
                    {
                        route: '/c/umbrella-stands-coat-stands/26878/',
                        text: 'Umbrella Stands & Coat Stands',
                    },
                    {
                        route: '/c/vases-garnitures/87/',
                        text: 'Vases & Garnitures',
                    },
                ],
            },
        ],
    },
    {
        columnCategories: [
            {
                headerText: 'Featured',
                links: [
                    {
                        route: getSearchUrlWithParams({
                            keyword:
                                'tiffany OR swarovski OR steuben OR moser OR loetz OR lalique OR imperial OR fenton OR daum OR blenko OR baccarat OR murano OR "stained glass" OR "art glass"',
                        }),
                        text: 'Art Glass',
                    },
                    {
                        route: '/c/baccarat/2618/',
                        text: 'Baccarat',
                    },
                    {
                        route: '/c/kpm/26128/',
                        text: 'KPM',
                    },
                    {
                        route: '/c/murano/25937/',
                        text: 'Murano',
                    },
                    {
                        route: getSearchUrlWithParams({
                            keyword: 'limoges',
                        }),
                        text: 'Limoges',
                    },
                    {
                        route: '/c/rookwood-pottery/21341/',
                        text: 'Rookwood',
                    },
                    {
                        route: '/c/sevres-porcelain/23056/',
                        text: 'Sèvres',
                    },
                    {
                        route: '/c/lalique/14553/',
                        text: 'Lalique',
                    },
                    {
                        route: '/c/tiffany-studios/23547/',
                        text: 'Tiffany Studios',
                    },
                    {
                        route: '/c/meissen/26157/',
                        text: 'Meissen',
                    },
                ],
            },
        ],
    },
];
export const fashion = [
    {
        columnCategories: [
            {
                headerText: 'Clothing',
                links: [
                    {
                        route: '/c/dresses-gowns/26840/',
                        text: 'Dresses & Gowns',
                    },
                    {
                        route: '/c/jackets-coats/26841/',
                        text: 'Jackets & Coats',
                    },
                    {
                        route: '/c/shirts-blouses/26845/',
                        text: 'Shirts & Blouses',
                    },
                    {
                        route: '/c/pants-trousers/26843/',
                        text: 'Pants & Trousers',
                    },
                    {
                        route: '/c/robes-kimonos/26844/',
                        text: 'Robes & Kimonos',
                    },
                    {
                        route: '/c/skirts/26847/',
                        text: 'Skirts',
                    },
                    {
                        route: '/c/suits-ensembles/26848/',
                        text: 'Suits & Ensembles',
                    },
                    {
                        route: '/c/sweaters/26849/',
                        text: 'Sweaters',
                    },
                    {
                        route: '/c/vets/26851/',
                        text: 'Vests',
                    },
                ],
            },
        ],
    },
    {
        columnCategories: [
            {
                headerText: 'Accessories',
                links: [
                    {
                        route: '/c/belts-chatelaines/26829/',
                        text: 'Belts & Chatelaines',
                    },
                    {
                        route: '/c/canes-walking-sticks/22/',
                        text: 'Canes & Walking Sticks',
                    },
                    {
                        route: '/c/eyeglasses-spectacles/26831/',
                        text: 'Eyeglasses & Spectacles',
                    },
                    {
                        route: '/c/handbags-purses/26833/',
                        text: 'Handbags & Purses',
                    },
                    {
                        route: '/c/handkerchiefs-pocket-squares/26834/',
                        text: 'Handkerchiefs & Pocket Squares',
                    },
                    {
                        route: '/c/neckties-bowties-bolo-ties/26836/',
                        text: 'Neckties & Bow Ties',
                    },
                    {
                        route: '/c/scarves-wraps-shawls/26837/',
                        text: 'Scarves, Wraps & Shawls',
                    },
                    {
                        route: '/c/shoes/26442/',
                        text: 'Shoes',
                    },
                    {
                        route: '/c/wallets/26839/',
                        text: 'Wallets',
                    },
                ],
            },
        ],
    },
    {
        columnCategories: [
            {
                headerText: 'Featured Designers',
                links: [
                    {
                        route: '/c/fashion/chanel/3/4017/',
                        text: 'Chanel',
                    },
                    {
                        route: '/c/fashion/christian-dior/3/4461/',
                        text: 'Christian Dior',
                    },
                    {
                        route: '/c/fashion/chloe/3/4385/',
                        text: 'Chloe',
                    },
                    {
                        route: '/c/fashion/gucci/3/9450/',
                        text: 'Gucci',
                    },
                    {
                        route: '/c/fashion/hermes/3/10420/',
                        text: 'Hermes',
                    },
                    {
                        route: '/c/fashion/louis-vuitton/3/15385/',
                        text: 'Louis Vuitton',
                    },
                    {
                        route: '/c/fashion/michael-kors/3/17295/',
                        text: 'Michael Kors',
                    },
                    {
                        route: '/c/fashion/yves-saint-laurent/3/25497/',
                        text: 'Yves Saint Laurent',
                    },
                ],
            },
        ],
    },
];
